module.exports = __webpack_public_path__ + "static/media/credit-card (8)new loanx3.b0b3ac9c.svg";